import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageSquare, X, Send } from "lucide-react";

const messages = [
  { from: "agent", name: "Sarah · Funding Specialist", text: "Hi 👋 — what's your monthly revenue range?" },
  { from: "user", text: "Around $80K / month." },
  { from: "agent", name: "Sarah", text: "Great. You'd qualify for $75K–$110K with 24-hour funding. Want me to lock in your terms?" },
];

export default function LiveChatMockup() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-40" data-testid="livechat-mockup">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 16, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 16, scale: 0.96 }}
            transition={{ duration: 0.22, ease: "easeOut" }}
            className="mb-4 w-80 md:w-96 bg-[#0A1326]/95 backdrop-blur-xl border border-white/10 shadow-[0_20px_60px_rgba(0,0,0,0.7)]"
          >
            <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
              <div className="flex items-center gap-3">
                <div className="relative">
                  <div className="w-9 h-9 bg-gold/15 border border-gold/40 rounded-full flex items-center justify-center text-gold font-heading">S</div>
                  <span className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-emerald-400 rounded-full ring-2 ring-[#0A1326] animate-pulse" />
                </div>
                <div>
                  <div className="text-white text-sm font-semibold">Sarah · Live</div>
                  <div className="text-white/50 text-xs">Replies in ~2 minutes</div>
                </div>
              </div>
              <button onClick={() => setOpen(false)} aria-label="Close chat" className="text-white/60 hover:text-white">
                <X className="w-4 h-4" />
              </button>
            </div>

            <div className="p-5 space-y-3 max-h-72 overflow-y-auto">
              {messages.map((m, i) => (
                <div key={i} className={`flex ${m.from === "user" ? "justify-end" : "justify-start"}`}>
                  <div
                    className={`max-w-[80%] px-4 py-2.5 text-sm leading-relaxed ${
                      m.from === "user"
                        ? "bg-gold text-navy-950"
                        : "bg-white/5 border border-white/10 text-white"
                    }`}
                  >
                    {m.text}
                  </div>
                </div>
              ))}
            </div>

            <div className="border-t border-white/10 p-3 flex items-center gap-2">
              <input
                type="text"
                placeholder="Type a message…"
                className="flex-1 bg-transparent text-sm text-white placeholder-white/30 px-3 py-2 outline-none"
                onChange={() => {}}
              />
              <button className="w-9 h-9 bg-gold text-navy-950 flex items-center justify-center hover:bg-gold-400">
                <Send className="w-4 h-4" />
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <button
        data-testid="livechat-toggle"
        onClick={() => setOpen((v) => !v)}
        aria-label="Open live chat"
        className="relative w-14 h-14 bg-gold text-navy-950 flex items-center justify-center rounded-full shadow-[0_8px_30px_rgba(212,175,55,0.35)] hover:scale-105 transition-transform"
      >
        <span className="absolute inset-0 rounded-full animate-pulse-gold" />
        {open ? <X className="w-5 h-5 relative" /> : <MessageSquare className="w-5 h-5 relative" />}
        {!open && (
          <span className="absolute -top-1 -right-1 w-3.5 h-3.5 bg-emerald-400 rounded-full ring-2 ring-[#050B14]" />
        )}
      </button>
    </div>
  );
}
